import { useEffect, useState } from 'react';

import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetRoleCustomPaymentTypeAccess = (roleId) => {
  const [customPaymentTypeAccess, setCustomPaymentTypeAccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRoleCustomPaymentTypeAccess = async () => {
    if (!roleId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await RolesApi.getRoleCustomPaymentTypeAccess(roleId);
      const nextAccess = response.data.data;
      setCustomPaymentTypeAccess(nextAccess);
      return nextAccess;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        'Failed to fetch role custom payment type access';
      setError(errorMessage);
      console.error('Error fetching role custom payment type access:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoleCustomPaymentTypeAccess().catch(() => {});
  }, [roleId]);

  return {
    customPaymentTypeAccess,
    loading,
    error,
    refetch: fetchRoleCustomPaymentTypeAccess,
  };
};
